@if (url) {
    @if (externalLink) {
        <a [href]="url" target="_blank" wdxStopPropagation>{{ label }}</a>
    } @else {
        <a [routerLink]="[url]" [target]="target" wdxStopPropagation>{{
            label
        }}</a>
    }
}
